export default __webpack_public_path__ + "static/media/gallery_02.d65c3dc7.jpg";